import React, { Component } from "react";
import { CSVLink } from "react-csv";
import map from "lodash/map";
import get from "lodash/get";
import has from "lodash/has";
import moment from "moment";
import unionBy from "lodash/unionBy";
import isEmpty from "lodash/isEmpty";
import { isMobile } from "../../../utils/deviceInfo";

class ExportMetrics extends Component {
  getCreatedByName = item => {
    if (
      !isEmpty(item.firstName) ||
      (!isEmpty(item.lastName) &&
        item["firstName"] !== undefined &&
        item["lastName"] !== undefined)
    ) {
      return `${item.firstName} ${item.lastName}`;
    }
    return "NA";
  };

  getData = data => {
    const csvData = [];
    map(data, d => {
      let eachUserRow = {
        name: d.name,
        createdDate: moment(d.createdAt).format("MM/DD/YYYY"),
        groupOwner: this.getCreatedByName(d.groupOwner),
        membersCount: d.members.length,
        eventsCount: d.eventsCount,
        toolsCount: d.toolsCount,
        actionsCount: d.actionsCount,
        chartCount: d.chartCount,
      };
      csvData.push(eachUserRow);
    });
    return csvData;
  };

  render() {
    const groupStaticHeaders = [
      { label: "Group Name", key: "name" },
      { label: "Date Created", key: "createdDate" },
      { label: "Group Admin", key: "groupOwner" },
      { label: "Number of Members", key: "membersCount" },
      { label: "Number of Events", key: "eventsCount" },
      { label: "Number of Resources", key: "toolsCount" },
      { label: "Number of Actions", key: "actionsCount" },
      { label: "Number of Charts", key: "chartCount" },
    ];
    const { groupMetrics } = this.props;
    return (
      <div
        className={`col-lg-12 col-md-12 col-sm-12 tool-list-font ${
          isMobile ? "" : "text-right"
        }`}
      >
        <span className="linkclass" style={{ lineHeight: "42px" }}>
          {/*<i
            className="flaticon-export"
            style={{ marginRight: "8px", fontSize: "12px" }}
          ></i>*/}
          <CSVLink
            data={this.getData(groupMetrics)}
            headers={groupStaticHeaders}
            filename={`Metrics Export -${moment().format("MM/DD/YYYY")}.csv`}
            separator={","}
            target="_blank"
            style={{ color: "white" }}
          >
            Export to CSV
          </CSVLink>
        </span>
      </div>
    );
  }
}

export default ExportMetrics;
